import React from "react";
import "./styles/index.css";
import LoginForm from "./components/LoginForm";
function App() {
  return (
    <div>
      <LoginForm />
    </div>
  );
}

export default App;
